import React from 'react';
import { isEmpty } from 'lodash';
import { motion } from 'framer-motion';
import BoxedContainer from '../layouts/BoxedContainer';
import FitnessBookingDesktop from './FitnessBookingDesktop';
import FitnessBookingMobile from './FitnessBookingMobile';

export default function FitnessBooking({ data }) {
  const { title, text, dswBookingCalendarList } = data;
  return (
    <section
      className="lg:pt-[185px] pt-[80px] lg:pb-[190px] pb-[80px] bg-white overflow-hidden
    clip-right-top lg:-mt-[90px] -mt-[20px]"
      id="booking-calendar"
    >
      <BoxedContainer className="regular">
        <div className="flex flex-col lg:gap-y-[70px] gap-y-[30px]">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            viewport={{ once: true }}
            className="flex flex-col lg:gap-y-[30px] gap-y-[10px]"
          >
            <h3
              className="text-primary font-roboto-condensed-bold 2xl:text-2xl lg:text-[38px]
                lg:leading-[55px] text-[30px] leading-[40px]  uppercase"
            >
              {title}
            </h3>
            {isEmpty(text) || (
              <p
                className="max-w-[770px] font-roboto-regular lg:text-base text-[15px]
                    leading-7 text-primary"
              >
                {text}
              </p>
            )}
          </motion.div>
          <FitnessBookingDesktop dswBookingCalendarList={dswBookingCalendarList} />
          <FitnessBookingMobile dswBookingCalendarList={dswBookingCalendarList} />
        </div>
      </BoxedContainer>
    </section>
  );
}
